import styled, { css } from "styled-components";
import downArrow from "../../../assets/icons/downArrow.svg";

export const StyledFormSelect = styled.select`
  box-sizing: border-box;
  width: 100%;

  border: 1px solid var(--LIGHT-ASH, #b9b9c6);
  border-radius: 4px;
  background: var(--CLOUD, #fcfdfe);
  color: var(--ASH, #676879);
  font-size: 14px;
  font-weight: 400;
  margin-bottom: 4px;

  /* hide native arrow */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  &::-ms-expand {
    display: none;
  }

  &:disabled {
    opacity: 0.5;
    cursor: not-allowed;
  }

  ${({ multiple }) =>
    multiple
      ? css`
          background-image: none !important;
          height: 176px;
          line-height: 32px;
          overflow: auto;
          padding: 8px 4px 8px 12px;
          scrollbar-width: thin;

          &::-webkit-scrollbar {
            width: 8px;
            height: 8px;
          }
        `
      : css`
          background-image: url(${downArrow});
          background-origin: content-box;
          background-position: right 11px center;
          background-repeat: no-repeat;
          height: 32px;
          padding-left: 12px;
        `}
`;

export const StyledFormOption = styled.option`
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 1;
  overflow: hidden;
  color: var(--ASH, #676879);
  text-overflow: ellipsis;
  font-size: 14px;
  font-weight: 400;
  line-height: 22px;
  padding-bottom: 5px;
  padding-top: 5px;

  &:checked {
    background-color: var(--Ghost, #efeffd);
  }

  &.__other__ {
    color: var(--Primary-Blue, #2060ea);
  }

  &.error {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  &.link {
    color: var(--Primary-Blue, #2060ea);
    cursor: pointer;
  }
`;

export const StyledFormTableSelect = styled.select`
  box-sizing: border-box;
  width: 100%;

  background: var(--CLOUD, #fcfdfe);
  color: var(--ASH, #676879);
  border: none;
  outline: none;
  cursor: text;

  /* hide native arrow */
  appearance: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  &::-ms-expand {
    display: none;
  }

  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='8' height='6' viewBox='0 0 8 6' fill='none'%3E%3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M0 1.30542C0.00237131 1.33999 0.00208521 1.34879 0.00797129 1.38302C0.0212574 1.45999 0.0504303 1.53403 0.0932894 1.59934C0.114947 1.63237 0.140149 1.6612 0.167036 1.69L3.59575 5.11872C3.6211 5.14238 3.62687 5.14898 3.65456 5.16998C3.68564 5.19355 3.71916 5.21393 3.75442 5.2307C3.90845 5.30396 4.09123 5.30396 4.24527 5.2307C4.28053 5.21393 4.31404 5.19355 4.34513 5.16998C4.37279 5.14898 4.37859 5.14238 4.4039 5.11872L7.83262 1.69C7.85628 1.66466 7.86291 1.65886 7.88388 1.6312C7.939 1.55857 7.9762 1.47285 7.99171 1.38302C8.00274 1.31887 8.00274 1.25296 7.99171 1.18881C7.98286 1.13752 7.96697 1.08749 7.94463 1.04049C7.85974 0.861969 7.68364 0.737678 7.48701 0.717448C7.40929 0.709476 7.33014 0.71762 7.25568 0.74125C7.19365 0.760936 7.13511 0.791252 7.08327 0.830567C7.05559 0.851569 7.04982 0.858169 7.02447 0.881827L3.99983 3.90647L0.975184 0.881827L0.946669 0.855197C0.91981 0.833339 0.913553 0.82711 0.884523 0.808081C0.830121 0.772394 0.769632 0.746107 0.70643 0.730706C0.655856 0.718391 0.603626 0.71302 0.551623 0.714791C0.354043 0.721534 0.169892 0.833539 0.0730028 1.00583C0.0411153 1.06255 0.0190287 1.12469 0.00797129 1.18881C0.00208521 1.22304 0.00237131 1.23184 0 1.26642C0 1.27942 0 1.29242 0 1.30542Z' fill='%234A4A68'/%3E%3C/svg%3E");
  background-origin: content-box;
  background-position: right 0px center;
  background-repeat: no-repeat;
  background-size: 8px 6px;
  padding: 0 4px 0 12px;
`;

export const StyledSelectAntDiv = styled.div`
  .ant-select,
  .ant-select-selection-placeholder {
    text-overflow: ellipsis;
    font-family: Inter;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: 22px;
    background: var(--Cloud, #fcfdfe);
    color: var(--ASH, #676879);
    .ant-select-selector {
      border-radius: 4px;
      color: var(--ASH, #676879);
      border: none;
      background: var(--Cloud, #fcfdfe);
      /* outline is drawn outside the border box and remains visible at all zoom levels.
      outline-offset -2px pulls it inward to create a border-like appearance that
      doesn't disappear when the page is zoomed to 70-80% */
      box-sizing: border-box;
      outline: 1px solid var(--Light-Ash, #b9b9c6) !important;
    }
  }

  .ant-select-focused:not(.ant-select-status-error) .ant-select-selector,
  .ant-select-open:not(.ant-select-status-error) .ant-select-selector {
    outline: 1px solid var(--DARK-BLUE, #1249bf) !important;
    box-shadow: none !important;
  }

  .ant-select-disabled {
    background: #f7f8f98c;
    .ant-select-selector,
    .ant-select-selection-search {
      background: #f7f8f98c !important;
    }
  }

  .ant-select-status-error .ant-select-selector {
    border: none !important;
  }

  &.multiple {
    .ant-select-multiple .ant-select-selection-item {
      background: var(--Sky, #cce5ff);
      color: var(--ASH, #676879);
      border: none;
      outline: none;
      cursor: text;
    }
  }
`;
